import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import CharacterCount from '../CharacterCount/CharacterCount';
import FormGroup from '../FormGroup/FormGroup';
import { useTextField } from 'react-aria';

const TextArea = (props) => {
    const [stringLength, setStringLength] = useState(props.value?.length || 0);
    const ref = useRef();
    const { inputProps, labelProps, errorMessageProps, descriptionProps } = useTextField(props, ref);
    inputProps.maxLength = null; // GDS does not want a character restriction on the text box if applied.
    return (
        <CharacterCount maxLength={props.maxLength} characterCount={stringLength} data-testid={props['data-testid']}>
            <FormGroup label={props.label} labelProps={labelProps} labelAsTitle={props.labelAsTitle} errorMessage={props.errorMessage} errorMessageProps={errorMessageProps} description={props.description} descriptionProps={descriptionProps} data-testid={props['data-testid']}>
                <textarea
                    { ...inputProps }
                    className={['govuk-textarea  govuk-js-character-count', (props.errorMessage ? 'govuk-textarea--error' : null)].join(' ')}
                    rows={props.rowCount}
                    value={props.value}
                    data-testid = {props['data-testid'] ? props['data-testid'] + '-input' : null}
                    onChange={(e) => { setStringLength(e.target.value.length); props.onChange && props.onChange(e); }}
                    onBlur={props.onBlur}
                ></textarea>
            </FormGroup>
        </CharacterCount>
    );
};

TextArea.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    labelAsTitle: PropTypes.bool,
    description: PropTypes.string,
    rowCount: PropTypes.number,
    value: PropTypes.string,
    errorMessage: PropTypes.string,
    maxLength: PropTypes.number,
    'data-testid': PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func
};

TextArea.defaultProps = {
    rowCount: 5,
    maxLength: 200
};

export default TextArea;
